import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

interface CardNewsProps {
    foto: string;
    width: string;
    indirizzo?: string;
    settore1?: string;
    settore2?: string;
    posizioneFoto: string;
}

function CardInEvidenzaFoto({ foto, width, indirizzo, settore1, settore2, posizioneFoto }: CardNewsProps) {
    const navigate = useNavigate();

    return (
        <motion.div
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            style={{
                maxWidth: "20em",
                margin: "1.5em",
                border: "5px solid #032041",
                borderRadius: "15px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                cursor: "pointer",
                overflow: "hidden",
            }}
            onClick={() => indirizzo && navigate(`${indirizzo}`)}
        >
            <div style={{ width: "100%" }}>
                <img
                    src={foto}
                    className="card-img-top m-auto"
                    alt="news"
                    style={{
                        width: "100%",
                        aspectRatio: "2300/1600",
                        objectFit: "cover",
                        objectPosition: posizioneFoto,
                        display: "block",
                    }}
                />
            </div>
            <div
                className="card-footer"
                style={{
                    width: "102%",
                    backgroundColor: "#032041",
                    color: "white",
                    padding: "0.4em",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    gap: "6px",
                }}
            >
                {settore1 && <NavLink to={`/${settore1}`} style={{ color: "white" }}>{settore1}</NavLink>}
                {settore2 && <NavLink to={`/${settore2}`} style={{ color: "white" }}>{settore2}</NavLink>}
            </div>
        </motion.div>
    );
}

export default CardInEvidenzaFoto;
